import { applyMiddleware, createStore } from "redux";
import { reducers } from "./Reducers/index";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "persist-key",
  storage,
  whitelist: ["loggedInUser"],
  blacklist: [
    "videoScheduleInformation",
    "videoStreamData",
    "manageBreakDownData",
    "videoHighlightData",
    "VideoLibraryDataTable",
    "popupInformation",
    "FeedPageData",
    "videoLibraryFilterData",
    "ColumnSetData",
    "BreakdownRequestData",
    "IntercutVideoData",
  ],
};

const persisterReducer = persistReducer(persistConfig, reducers);
const store = createStore(persisterReducer, {}, applyMiddleware(thunk));
const persistor = persistStore(store);
export { persistor, store };
